export default __webpack_public_path__ + "static/media/blue-bar.5dcb65c2.png";